import { styled } from '../ui';
import Button from '../ui/Button';

const EnterButton = styled(Button, {
  shouldForwardProp: (prop) =>
  (prop !== 'mColor' &&
    prop !== 'mbgcolor' &&
    prop !== 'mborderradius' &&
    prop !== 'sx' ) // optional, but good to keep MUI props clean
    || ['disableRipple', 'onPointerDown', 'onClick', 'variant', 'color', 'disabled'].includes(prop),
})(
  ({ theme, mColor = '#ffffff', mbgcolor = '#313033', mborderradius = '0px' }) => ({
    border: '1px solid #00333e',
    backgroundColor: mbgcolor,
    color: mColor,
    clipPath: 'polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%)',
    fontFamily: 'monospace',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#000f12',
    },
    '&:active': {
      transform: 'scale(0.95)',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
    },
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
  })
);

export default EnterButton;